import { PaginationReq, PaginationResp, UpdaterResp } from "@/core/interface";

export class ApprovalFLowLogPageReq extends PaginationReq {
  bizId: string | undefined = undefined;
  bizType: string | undefined = undefined;
}

export class ApprovalFLowLogPageReqPageRecord extends UpdaterResp {
  currentNodeSnapshootName: string = ""; // 节点名称
  flowStatusDesc: string = ""; // 节点状态
  remark: string = ""; // 审批意见
  createName: string = ""; // 提交人
  nextTenantUserRealName: string[] = []; // 审批人（下一节点）
  createTime: string = ""; // 提交时间
}

export class ApprovalFLowLogListResp extends PaginationResp<ApprovalFLowLogPageReqPageRecord> {}
